import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DLPRestUtilityService } from 'src/app/services/rest/dlprest-utility.service';
import { TitleCasePipe } from '@angular/common';

import { HttpErrorResponse } from '@angular/common/http';
import { LoginRenderingService } from 'src/app/services/login/login-rendering.service';
import { RecentActivitiesLabelEN } from 'src/app/models/labels/recentActivitiesLabel_EN';

@Component({
  selector: 'app-my-recent-activites',
  templateUrl: './my-recent-activites.component.html',
  styleUrls: ['./my-recent-activites.component.scss']
})
export class MyRecentActivitesComponent implements OnInit {

  previewResponse: any = new Object();
  show: boolean = false;
  dropdownClass: any;
  datePickerClass: any;
  label: any;

  constructor(private router: Router,

    private dlpRestUtilityService: DLPRestUtilityService, private titlecasePipe: TitleCasePipe,
    private loginRenderingService: LoginRenderingService) { }

  ngOnInit() {

    this.label = new RecentActivitiesLabelEN();
    this.dropdownClass = { 'form-group': true, 'col-12': true };
    this.datePickerClass = { 'form-group': true, 'col-12': true };
    this.loginRenderingService.login.checkHomePage = true;

    this.dlpRestUtilityService.recentActivities().subscribe((res) => {
      this.previewResponse = res;
      this.previewResponse.forEach(element => {
        element.updateDate = element.updateDate.slice(0, 10);
      });
      this.show = true;
    },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          // A client-side or network error occurred.				 
          console.log('An error occurred:', err.error.message);
        } else {
          //  Backend returns unsuccessful response codes such as 404, 500 etc.
          console.log('Backend returned status code: ', err.status);
          console.log('Response body:', err.error);

        }
      });
  }

  // track() {
  //   this.router.navigate(['/trackQuote', { outlets: { 'track': ['statusTracker'] } }]);
  // }
  dob(value) {

    let dob;
    if (typeof (value) === 'string') {
      dob = new Date(value);
    } else {
      dob = value;
    }

    let year = dob.getFullYear();
    let month = dob.getMonth() + 1;
    let date = dob.getDate();


    if (date < 10) {
      date = '0' + date;
    }
    if (month < 10) {
      month = '0' + month;
    }

    dob = date + '-' + month + '-' + year;
    return dob;
  }


}
